import {create} from 'zustand';

const useSelectionStore = create((set) => ({
  selectedDataset: null,
  categoriUpdate: null,
  setSelectedDataset: (datasetId) => set({ selectedDataset: datasetId }),
  setCategoriUpdate: (updateStatus) => set({ categoriUpdate: updateStatus }),
  resetSelection: () =>
    set({ selectedDataset: null, categoriUpdate: null }), 
}));


export default useSelectionStore;
